(function () {
  'use strict';

  function initPremiumFooter(root) {
    if (!root || root.dataset.tpFooterReady === 'true') return;

    root.dataset.tpFooterReady = 'true';

    /* Smooth hover interaction */
    const links = root.querySelectorAll(
      '.tp-footer-menu a, .tp-contact-item, .tp-talk-card'
    );

    links.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        link.classList.add('tp-hover');
      });

      link.addEventListener('mouseleave', function () {
        link.classList.remove('tp-hover');
      });
    });

    /* Newsletter submit feedback */
    const forms = root.querySelectorAll('.tp-newsletter-form');

    forms.forEach(function (form) {
      form.addEventListener('submit', function () {
        const button = form.querySelector('button');

        if (!button) return;

        button.dataset.originalText = button.textContent;
        button.textContent = 'SUBMITTING...';
      });
    });
  }

  function boot() {
    document
      .querySelectorAll('.tp-footer')
      .forEach(initPremiumFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector
      ? event.target.querySelector('.tp-footer')
      : null;

    if (section) {
      initPremiumFooter(section);
    }
  });

})();